export default {
    title: 'Learn more about formatter',
    add: {
        title: 'Adding JSON to JXformatter',
        text1: 'Paste your JSON into the text field and formatter will evaluate it.',
        text2: 'If your JSON is valid, you can format it by clicking the button “Run”, failing which error message with description will be displayed.',
        text3: 'If STRING property which is valid JSON is found in formatted JSON, the formatter will format given value.'
    },
    generated: {
        title: 'The generated JSON tree provides the following options:',
        openClose: {
            title: 'to roll …. all child nodes simultaneously'
        },
        edit: {
            title: 'to edit single properties by double-click on name or value'
        },
        addnew: {
            title: 'to add new properties in menu by "Create child item"'
        },
        editMenu: {
            title: 'to edit single properties in settings of one specific property'
        },
        propType: {
            title: 'when selecting a type of property (object or array) it is possible to select output format - ',
            text: 'either the type of property or the string.'
        },
        propOutputType: {
            title: 'Selected output property type STRING then output converted to string',
            text: 'see that on "dataString"'
        },
        copy: {
            title: 'copy and paste selected node ',
            text: 'it is possible to copy and paste selected node or variable only into object or array',
        }
    },
    search: {
        title: 'Full – text search',
        text: 'Above JSON tree it is possible to search name of property or it‘s value.'
    },
    output: {
        title: 'Output',
        text: 'Checkbox at single values enable back conversion of selected values to outputted formatted JSON form.'
    }
}
